export const CATALOGS = [
  {
    key: 'activities',
    table: 'activities',
    label: 'Actividades Registrables',
    singular: 'Actividad',
    select: '*, hour_types(name)',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Actividad' },
      { key: 'hour_types.name', label: 'Tipo de Hora' },
    ],
    fields: [
      { key: 'name', label: 'Nombre de la actividad', type: 'text', required: true },
      { key: 'hour_type_id', label: 'Tipo de Hora', type: 'fk', required: true, fkTable: 'hour_types', fkLabel: 'name' },
    ],
  },
  {
    key: 'hour_types',
    table: 'hour_types',
    label: 'Tipos de Hora',
    singular: 'Tipo de Hora',
    select: '*',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Nombre' },
    ],
    fields: [
      { key: 'name', label: 'Nombre del tipo de hora', type: 'text', required: true },
    ],
  },
  {
    key: 'billing_types',
    table: 'billing_types',
    label: 'Tipos de Facturación',
    singular: 'Tipo de Facturación',
    select: '*',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Nombre' },
    ],
    fields: [
      { key: 'name', label: 'Nombre del tipo de facturación', type: 'text', required: true },
    ],
  },
  {
    key: 'clients',
    table: 'clients',
    label: 'Clientes',
    singular: 'Cliente',
    select: '*',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Nombre del Cliente' },
    ],
    fields: [
      { key: 'name', label: 'Nombre del cliente', type: 'text', required: true },
    ],
  },
  {
    key: 'projects',
    table: 'projects',
    label: 'Proyectos de Clientes',
    singular: 'Proyecto',
    select: '*, clients(name)',
    orderBy: 'name',
    columns: [
      { key: 'clients.name', label: 'Cliente' },
      { key: 'name', label: 'Proyecto' },
    ],
    fields: [
      { key: 'client_id', label: 'Cliente', type: 'fk', required: true, fkTable: 'clients', fkLabel: 'name' },
      { key: 'name', label: 'Nombre del proyecto', type: 'text', required: true },
    ],
  },
  {
    key: 'rates',
    table: 'rates',
    label: 'Tarifas',
    singular: 'Tarifa',
    select: '*, clients(name)',
    orderBy: 'effective_from',
    columns: [
      { key: 'clients.name', label: 'Cliente' },
      { key: 'rate_type', label: 'Tipo', format: (v) => v === 'standard' ? 'Estándar' : v === 'extended' ? 'Extendida' : v },
      { key: 'hourly_rate', label: 'Tarifa/Hr', format: (v) => v != null ? `$${Number(v).toFixed(2)}` : '—' },
      { key: 'currency', label: 'Moneda' },
      { key: 'effective_from', label: 'Desde' },
      { key: 'effective_to', label: 'Hasta', format: (v) => v || 'Vigente' },
    ],
    fields: [
      { key: 'client_id', label: 'Cliente', type: 'fk', required: true, fkTable: 'clients', fkLabel: 'name' },
      { key: 'rate_type', label: 'Tipo de tarifa', type: 'select', required: true, options: [{ value: 'standard', label: 'Estándar' }, { value: 'extended', label: 'Extendida' }] },
      { key: 'hourly_rate', label: 'Tarifa por hora', type: 'number', required: true, step: '0.01', min: '0' },
      { key: 'currency', label: 'Moneda', type: 'select', required: true, default: 'MXN', options: [{ value: 'MXN', label: 'MXN' }, { value: 'USD', label: 'USD' }] },
      { key: 'effective_from', label: 'Vigencia desde', type: 'date', required: true },
      { key: 'effective_to', label: 'Vigencia hasta', type: 'date', required: false },
    ],
  },
  {
    key: 'specializations',
    table: 'specializations',
    label: 'Especializaciones',
    singular: 'Especialización',
    select: '*',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Nombre' },
    ],
    fields: [
      { key: 'name', label: 'Nombre de la especialización', type: 'text', required: true },
    ],
  },
  {
    key: 'status',
    table: 'status',
    label: 'Tipos de Status',
    singular: 'Status',
    select: '*',
    orderBy: 'name',
    columns: [
      { key: 'name', label: 'Nombre' },
      { key: 'color', label: 'Color' },
    ],
    fields: [
      { key: 'name', label: 'Nombre del status', type: 'text', required: true },
      { key: 'color', label: 'Color (hexadecimal)', type: 'color', required: true },
    ],
  },
];
